import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { useBuilder } from '../store/provider';
const useBlankReportName = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "agentBuilder.canvas.output"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t0);
  const {
    state
  } = useBuilder();
  let t1;
  if ($[1] !== state.bundle.name || $[2] !== t) {
    const agent = state.bundle.name.trim();
    t1 = agent ? t(_temp, {
      agent
    }) : t(_temp2);
    $[1] = state.bundle.name;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default useBlankReportName;
function _temp($) {
  return $.blankReportName;
}
function _temp2($_0) {
  return $_0.blankReportNameNoAgent;
}